import { useTheme } from '@emotion/react';
import { ELIGIBILITY_VALUE_MAP } from './types';

const MAX_VALUE = 100;

export type Eligibility = 'HIGH' | 'MEDIUM' | 'LOW';

type HalfGaugeProps = {
  elibigility: Eligibility;
  size?: number; // Size of the gauge (default is 200)
  strokeWidth?: number; // Width of the gauge stroke (default is 10)
};

const LoanEligibilityGauge = ({ elibigility, size = 200, strokeWidth = 15 }: HalfGaugeProps) => {
  const { colors } = useTheme();
  const colorMap: Record<Eligibility, string> = {
    HIGH: colors.textPositive,
    MEDIUM: colors.textWarning,
    LOW: colors.textNegative,
  };

  const value = ELIGIBILITY_VALUE_MAP[elibigility]; // Convert eligibility to a numeric value
  const radius = (size - strokeWidth) / 2;
  const circumference = Math.PI * radius; // Half-circle circumference
  const progress = Math.min(value / MAX_VALUE, 1) * circumference;

  return (
    <svg width={size} height={size / 1.5} viewBox={`0 0 ${size} ${size / 2}`}>
      {/* Background Arc */}
      <path
        d={`M ${strokeWidth / 2},${size / 2 - strokeWidth / 2}
            A ${radius},${radius} 0 0,1 ${size - strokeWidth / 2},${size / 2 - strokeWidth / 2}`}
        stroke="#e0e0e0"
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Progress Arc */}
      <path
        d={`M ${strokeWidth / 2},${size / 2 - strokeWidth / 2}
            A ${radius},${radius} 0 0,1 ${size - strokeWidth / 2},${size / 2 - strokeWidth / 2}`}
        stroke={colorMap[elibigility]}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={`${progress} ${circumference}`}
        strokeLinecap="round"
      />
      {/* Text Value */}
      <text
        x="50%"
        y="90%"
        textAnchor="middle"
        fontSize={size * 0.1}
        fontWeight="bold"
        fontFamily="Open Sans, sans-serif"
        fill={colorMap[elibigility]}
      >
        {elibigility}
      </text>
    </svg>
  );
};

export default LoanEligibilityGauge;
